import { FC } from 'react'
import { useQuery } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { CustomerLogo } from '@sequencehq/core-components'
import { getLogoSrc } from '../utils/logo'

/**
 * Renders a customer logo from just a customer ID, for list items whose
 * source data doesn't carry the customer domain. React Query caching dedupes
 * the lookup across list items sharing the same customer. Pass `staleTime` to
 * keep repeated lookups (e.g. across a search session) served from cache.
 */
export const CustomerLogoById: FC<{
  customerId?: string
  staleTime?: number
  'data-testid'?: string
}> = ({ customerId, staleTime, 'data-testid': dataTestId }) => {
  const customerQuery = useQuery(
    dashboardv99990101Client.getCustomer,
    { id: customerId ?? '' },
    { enabled: Boolean(customerId), staleTime }
  )

  const domain = customerQuery.data?.domain

  return (
    <CustomerLogo
      data-testid={dataTestId}
      src={domain ? getLogoSrc({ domain }) : undefined}
      size={24}
      fallbackSize={16}
    />
  )
}
